import { render, staticRenderFns } from "./AllocationChart.vue?vue&type=template&id=78a02914&scoped=true&"
import script from "./AllocationChart.vue?vue&type=script&lang=ts&"
export * from "./AllocationChart.vue?vue&type=script&lang=ts&"
import style0 from "./AllocationChart.vue?vue&type=style&index=0&id=78a02914&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a02914",
  null
  
)

export default component.exports